export default __webpack_public_path__ + "static/media/IMG_0044_1_11zon.2a4c8c7c.jpg";